import { LocationsApi } from '@frontend/api-locations';
import { useTranslation } from '@frontend/i18n';
import { useQuery } from '@frontend/react-query-helpers';
import { BannerNotification, ContentLoader, useAlert } from '@frontend/design-system';
import { DentalInsuranceEligibilityReport } from '../dental-insurance-eligibility-report';

interface InsuranceReportProps {
  locationId: string;
  personId: string;
  sourceId: string;
  personPMSId: string;
  onError?: () => void;
  closeInsuranceReportModal: () => void;
}

export const InsuranceReport = ({
  locationId,
  sourceId,
  personId,
  personPMSId,
  closeInsuranceReportModal,
  onError,
}: InsuranceReportProps) => {
  const alert = useAlert();
  const { t } = useTranslation('insuranceEligibilityReport');
  const { data: locationData, isLoading: isLoadingLocationData } = useQuery({
    queryKey: ['locations', locationId],
    queryFn: () => LocationsApi.getLocation(locationId),
    enabled: !!locationId,
    onError: () => alert.error(t('Failed to get location data')),
  });

  if (isLoadingLocationData) return <ContentLoader />;

  if (!locationData) {
    return <BannerNotification message={t('Failed to get location data')} status='error' />;
  }

  const locationVertical = locationData?.Vertical;

  if (locationVertical === 'Dental') {
    return (
      <div css={{ overflow: 'auto' }}>
        <DentalInsuranceEligibilityReport
          locationId={locationId}
          personId={personId}
          sourceId={sourceId}
          personPMSId={personPMSId}
          locationData={locationData}
          closeInsuranceReportModal={closeInsuranceReportModal}
          onError={onError}
        />
      </div>
    );
  }

  // TODO: Add support for other location verticals when reports are available for those verticals
  return (
    <BannerNotification
      message={t('Insurance Verification Report not supported for {{locationVertical}}', { locationVertical })}
      status='warn'
    />
  );
};
